import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  width: 247px;
  height: 208px;
  > span > div {
    height: 100%;
    width: 100%;
  }
`

interface IImageProps {
  url: string
}

export const Image = styled.div<IImageProps>`
  background-image: url(${(props) => props.url});
  background-size: cover;
  background-position: center center;
  background-color: #ccc;
  border-radius: 4px;
  height: 100%;
  transition: 200ms;
  box-shadow: 0px 4px 8px 0px #00000014;
`

export const RemoveImage = styled.div`
  float: right;
  margin-top: -7px;
  margin-right: -7px;
  svg {
    padding: 5px 7.7px;
    border-radius: 50%;
    color: #4c4c4c;
    background-color: white;
    box-shadow: 0px 4px 8px 0px #00000014;
    transition: 0.2s;
    cursor: pointer;
  }
  &:hover {
    svg {
      color: #757575;
    }
  }
`

interface IContainerProps {
  imageloaded: string
}

export const Container = styled.div<IContainerProps>`
  text-align: center;
  border: 2px dashed #d9d9d9;
  padding: 8px;
  border-radius: 4px;
  height: 100%;
  transition: 200ms;
  ${(props) =>
    props.imageloaded === 'false' &&
    css`
      cursor: pointer;
      &:hover {
        border-color: #2684ff;
      }
    `}
`

export const Content = styled.div`
  width: calc(100% - 20px);
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  button {
    margin-top: 5px;
    color: #2684ff;
    font-weight: 700;
  }
`

export const IconWrapper = styled.div`
  width: 72px;
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #f0f0f0;
  margin: 0 auto;
  svg {
    background-color: white;
    border-radius: 8px;
    color: #757575;
    padding: 10px;
    height: 20px;
  }
`

export const Title = styled.div`
  margin-top: 16px;
  color: #757575;
`

export const Subtitle = styled.div`
  color: #757575;
`
